import TasksTagsService from '@/modules/renter/tasksTags/services/TasksTagsService';
import { ANNUAL_STOCKTAKE_TAG_NAME } from '../constants';
import { findTagIdByName, shouldAttachAnnualStocktakeTag, withTag } from '../helpers/annualStocktakeTag';
import type { AnnualStocktakeTagForm } from '../types';

export function useAnnualStocktakeTag(): { apply: (form: AnnualStocktakeTagForm) => Promise<void> }
{
    let tagId: number | null = null;

    const apply = async (form: AnnualStocktakeTagForm): Promise<void> =>
    {
        if (!shouldAttachAnnualStocktakeTag(form.activities))
            return;

        if (tagId === null)
        {
            form.wait();

            try
            {
                const tags = await TasksTagsService.getAutocompleteList(ANNUAL_STOCKTAKE_TAG_NAME, 10);

                tagId = findTagIdByName(tags, ANNUAL_STOCKTAKE_TAG_NAME);
            }
            finally
            {
                form.continue();
            }

            if (tagId === null)
                throw new Error(`Tag "${ANNUAL_STOCKTAKE_TAG_NAME}" not found.`);
        }

        const next = withTag(form.tagsIds, tagId);

        if (next !== form.tagsIds)
            form.tagsIds = next;
    };

    return { apply };
}
